import React from 'react';
import { connect } from 'react-redux';
import { getActiveCategoryID } from '../../reducers/categories';

import { getCategories, getTopCategories } from '../../reducers/selectors';
import { getActiveSewpatId } from '../../reducers/sewpats';
import Heading from '../heading/Heading';
import CategoryPane from './CategoryPane';
import Top from '../common/GoToTop';

const CategoriesOverviewLanding = ({ isFetching, categories, topCategories, sewpatId, activeCategoryID }) => {
    const buildCategoryPanes = (activeCategoryID = null) => {
        var Panes = [];
        if (activeCategoryID) {
            Panes.push([
                <Heading
                    level={3} id={activeCategoryID}
                    text={topCategories[activeCategoryID].title} striped
                    margin='2.5rem 0 1rem'
                />, <CategoryPane
                    topCategory={topCategories[activeCategoryID]}
                    categories={categories} sewpatId={sewpatId}
                />]);
        }
        else {
            Object.entries(topCategories).map(topCategory => {
                Panes.push([
                    <Heading
                        level={3} id={topCategory[0]}
                        text={topCategory[1].title} striped
                        margin='2.5rem 0 1rem'
                    />, <CategoryPane
                        topCategory={topCategory[1]}
                        categories={categories} sewpatId={sewpatId}
                    />]);
            });
        }
        return Panes;
    };

    if (!categories) {
        return null;
    }

    return (

        <React.Fragment>
            {buildCategoryPanes(activeCategoryID)}
            <Top />
        </React.Fragment>
    );
};

const MapStateToProps = state => (
    {
        isFetching: state.stolo.entities.categories.isFetching,
        categories: getCategories(state),
        activeCategoryID: getActiveCategoryID(state),
        topCategories: getTopCategories(state.stolo.entities.categories),
        sewpatId: getActiveSewpatId(state),
    }
);

export default connect(MapStateToProps)(CategoriesOverviewLanding);



// WEBPACK FOOTER //
// ./src/components/categories/CategoriesOverviewLanding.js